/**
 * Canicule PDP tabs : aria-expanded sync (same pattern as FAQ)
 */
(function () {
  'use strict';

  function syncExpanded(panel) {
    var summary = panel.querySelector('summary');
    if (!summary) return;
    summary.setAttribute('aria-expanded', panel.open ? 'true' : 'false');
  }

  function init(root) {
    var panels = root.querySelectorAll('.canicule-pdp-tabs__panel');
    panels.forEach(function (panel) {
      var summary = panel.querySelector('summary');
      if (!summary) return;

      summary.setAttribute('role', 'button');
      syncExpanded(panel);

      panel.addEventListener('toggle', function () {
        syncExpanded(panel);
      });

      summary.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          panel.open = !panel.open;
        }
      });
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('.canicule-pdp-tabs').forEach(init);
  });

  document.addEventListener('shopify:section:load', function (e) {
    var section = e.target.querySelector('.canicule-pdp-tabs');
    if (section) init(section);
  });
})();
